export default __webpack_public_path__ + "static/media/tenisultramarine.5335d132.png";